import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('retr', ['reclamationDates', 'canComplaint', 'reclamationExists']),

        reclamation() {
            return this.reclamationExists({
                contractor: this.element.contractor,
                type: this.retrType
            })
        },

        reclamationIsFetching() {
            return this.reclamation === undefined
        },

        elementAlreadyReclaimed() {
            const reclamation = this.reclamation || {}

            if (!(reclamation.list || []).length) {
                return false
            }

            const element = reclamation.list.find(el => el.element === this.name)

            return !!element
        },

        btnDisabled() {
            return !this.canComplaint || this.elementAlreadyReclaimed || this.reclamationIsFetching
        },

        reclamationTooltip() {
            if (this.elementAlreadyReclaimed) {
                return 'Złożyłeś już reklamację na tę pozycję'
            }

            if (this.canComplaint) {
                // No need to display tooltip at all
                return null
            }

            const { dateFrom, dateTo } = (this.reclamationDates || {})

            if (!dateFrom || !dateTo) {
                return 'Nie możesz zgłosić reklamacji'
            }

            const formatDate = date => this.$moment(date).format('DD-MM-YYYY')

            return `
                Reklamacje za wybrany kwartał<br/>
                możesz zgłaszać w terminie:
                <ul class="retr__tooltip">
                    <li>od <strong>${formatDate(dateFrom)}</strong></li>
                    <li>do <strong>${formatDate(dateTo)}</strong></li>
                </ul>
            `
        }
    },

    methods: {
        setDateNow() {
            this.$store.commit('retr/SET_DATE_NOW',
                this.$moment().format('YYYY-MM-DD HH:mm:ss')
            )

            if (this.canComplaint) {
                return
            }
            this.$store.dispatch('addNotification', {
                type: 'danger',
                content: 'Minął termin zgłaszania reklamacji'
            })
        }
    }
}